/*

Load all the app static data. 

*/


import 'whatwg-fetch'; /* global fetch */
import { MEDIA_URI, API_URI } from './config';

export let backgrounds = [];
export let menuItems = [];
export let chapters = [];
export let slides = [];
export let colors = [];
export let conditions = [];
export let definitions = [];
export let surveys = [];
export let questions = [];


function loadBackgrounds() {
  return fetch(`${API_URI}/backgrounds`)
    .then(res => res.json())
    .then(json => {
      backgrounds = json.map(img => {
        const {path, filename} = img.photo;
        return `${MEDIA_URI}/${path}${filename}`;
      });
      console.log('loaded backgrounds', json);
    })
    .catch(err => console.error('Backgrounds Error', err));
}

function loadMenuItems() {
  return fetch(`${API_URI}/navitems`)
    .then(res => res.json())
    .then(items => {
      menuItems = items;
      console.log('loaded menuItems');
    })
    .catch(err => console.error('MenuItems Error', err));
}

function loadChapters() {
  return fetch(`${API_URI}/chapters`)
    .then(res => res.json())
    .then(res => {
      chapters = res;
      console.log('loaded chapters');
    })
    .catch(err => console.error('Chapters Error', err));
}

function loadDefinitions() {
  return fetch(`${API_URI}/definitions`)
    .then(res => res.json())
    .then(res => {
      definitions = res;
      console.log('loaded definitions', res);
    })
    .catch(err => console.error('Definitions Error', err));
}

function loadSlides() {
  return fetch(`${API_URI}/slides`)
    .then(res => res.json())
    .then(res => {
      slides = res;
      console.log('loaded slides', slides);
    })
    .catch(err => console.error('Slides Error', err));
}

function loadColors() {
  return fetch(`${API_URI}/colors`)
    .then(res => res.json())
    .then(res => {
      colors = res;
      console.log('loaded colors');
    })
    .catch(err => console.error('Colors Error', err));
}

function loadConditions() {
  return fetch(`${API_URI}/conditions`)
    .then(res => res.json())
    .then(res => {
      conditions = res.conditions;
      console.log('loaded conditions', conditions);
    })
    .catch(err => console.error('Conditions Error', err));
}

function loadSurveys() {
  return fetch(`${API_URI}/surveys`)
    .then(res => res.json())
    .then(res => {
      surveys = res;
      console.log('loaded surveys', res);
    })
    .catch(err => console.error('Surveys Error', err));
}

function loadQuestions() {
  return fetch(`${API_URI}/questions`)
    .then(res => res.json())
    .then(res => {
      questions = res;
      console.log('loaded questions', res);
    })
    .catch(err => console.error('Questions Error', err));
}

export function load() {
  const loaders = [
    loadBackgrounds(),
    loadMenuItems(),
    loadChapters(),
    loadSlides(),
    loadColors(),
    loadConditions(),
    loadDefinitions(),
    loadSurveys(),
    loadQuestions()
  ];
  return Promise.all(loaders);
}


// WEBPACK FOOTER //
// ./src/services/content.js